<template>
  <FilteringFacetsHorizontalFacets
    name="facet"
    :options="facetsOptions"
    :disable-auto-outlined="true"
    @on-facet-click="facetClick"
    @on-close-facet-dropdown="facetDropdownClose"
  />
</template>

<script setup>
import { useSlideoutStore } from '@nuxt-common/atomic-ui/app/stores/useSlideoutStore';

const filteringFacetsStore = useFilteringFacetsStore();
const slideouteStore = useSlideoutStore();
const { activeDropdown, facetsOptions, buildFacetsList } = useFacetOptions();
const { isMobile } = useDisplay();
const { buildSections } = useSortFilter();

const facetClick = (facet) => {
  if (isMobile.value) {
    buildSections({
      facetId: facet.selected.id,
      sortBySelectedValue: filteringFacetsStore.getSortBy.selectedValue,
      facets: filteringFacetsStore.getFacets,
    });
    slideouteStore.toggle('sort-and-filter');
  } else {
    activeDropdown.value = facet.dropdownRef;
  }
};

const facetDropdownClose = () => {
  activeDropdown.value = null;
  filteringFacetsStore.getAllSelectedCriteria();
};

buildFacetsList();
</script>

<style lang="scss" scoped>
:deep(.checkbox-container) {
  margin-right: rem-calc(48);
}
</style>
